export default __webpack_public_path__ + "static/media/pup_icon.3db8c60b.png";